export const ALL_PRODUCTS_REQUESTS = "ALL_PRODUCTS_REQUESTS";
export const ALL_PRODUCTS_SUCCESS = "ALL_PRODUCTS_SUCCESS";
export const ALL_PRODUCTS_FAIL = "ALL_PRODUCTS_FAIL";

export const PRODUCT_DETAILS_REQUEST = "PRODUCT_DETAILS_REQUEST";
export const PRODUCT_DETAILS_SUCCESS = "PRODUCT_DETAILS_SUCCESS";
export const PRODUCT_DETAILS_FAIL = "PRODUCT_DETAILS_FAIL";

export const SEARCH_PRODUCTS_REQUEST = "SEARCH_PRODUCTS_REQUEST";
export const SEARCH_PRODUCTS_SUCCESS = "SEARCH_PRODUCTS_SUCCESS";
export const SEARCH_PRODUCTS_FAIL = "SEARCH_PRODUCTS_FAIL";

export const NEW_REVIEW_REQUEST = "NEW_REVIEW_REQUEST";
export const NEW_REVIEW_SUCCESS = "NEW_REVIEW_SUCCESS";
export const NEW_REVIEW_RESET = "NEW_REVIEW_RESET";
export const NEW_REVIEW_FAIL = "NEW_REVIEW_FAIL";

export const ADMIN_PRODUCTS_REQUESTS = "ADMIN_PRODUCTS_REQUESTS";
export const ADMIN_PRODUCTS_SUCCESS = "ADMIN_PRODUCTS_SUCCESS";
export const ADMIN_PRODUCTS_FAIL = "ADMIN_PRODUCTS_FAIL";

export const ADMIN_CREATE_PRODUCTS_REQUESTS = "ADMIN_CREATE_PRODUCTS_REQUESTS";
export const ADMIN_CREATE_PRODUCTS_SUCCESS = "ADMIN_CREATE_PRODUCTS_SUCCESS";
export const ADMIN_CREATE_PRODUCTS_FAIL = "ADMIN_CREATE_PRODUCTS_FAIL";
export const ADMIN_CREATE_PRODUCTS_RESET = "ADMIN_CREATE_PRODUCTS_RESET";

export const ADMIN_UPDATE_PRODUCTS_REQUESTS = "ADMIN_UPDATE_PRODUCTS_REQUESTS";
export const ADMIN_UPDATE_PRODUCTS_SUCCESS = "ADMIN_UPDATE_PRODUCTS_SUCCESS";
export const ADMIN_UPDATE_PRODUCTS_FAIL = "ADMIN_UPDATE_PRODUCTS_FAIL";
export const ADMIN_UPDATE_PRODUCTS_RESET = "ADMIN_UPDATE_PRODUCTS_RESET";

export const ADMIN_DELETE_PRODUCTS_REQUESTS = "ADMIN_DELETE_PRODUCTS_REQUESTS";
export const ADMIN_DELETE_PRODUCTS_SUCCESS = "ADMIN_DELETE_PRODUCTS_SUCCESS";
export const ADMIN_DELETE_PRODUCTS_FAIL = "ADMIN_DELETE_PRODUCTS_FAIL";
export const ADMIN_DELETE_PRODUCTS_RESET = "ADMIN_DELETE_PRODUCTS_RESET";

export const ADMIN_ALL_REVIEWS_REQUESTS = "ADMIN_ALL_REVIEWS_REQUESTS";
export const ADMIN_ALL_REVIEWS_SUCCESS = "ADMIN_ALL_REVIEWS_SUCCESS";
export const ADMIN_ALL_REVIEWS_FAIL = "ADMIN_ALL_REVIEWS_FAIL";
export const ADMIN_ALL_REVIEWS_RESET = "ADMIN_ALL_REVIEWS_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS";